import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import MiscellaneousPeriodicCostsFormHandler from '@Modules/cardManagementSystem/prepaid/containers/formHandlers/globalParameters/miscellaneousPeriodicCosts/MiscellaneousPeriodicCostsFormHandler';

export default function MiscellaneousPeriodicCosts() {
  return (
    <>
      <CC.Box>
        <CC.Text fontSize={20} fontWeight="bold" mb="4">
        Frais Periodiques Divers
        </CC.Text>
        <MiscellaneousPeriodicCostsFormHandler />
      </CC.Box>
    </>
  );
}